import { render, staticRenderFns } from "./CadastroBanner.vue?vue&type=template&id=97a9236a"
import script from "./CadastroBanner.vue?vue&type=script&lang=js"
export * from "./CadastroBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports